import type { ItemUnintEntity } from "./ItemUnintEntity";
import type { AppliedDiscountOnItemEntity } from "./AppliedDiscountOnItemEntity";
import type { SelectionListedEntity } from "./SelectionListedEntity";

export class OrderItemsEntity {
    id?: number;
    branchId?: number;
    name?: string | null;
    imageUrl?: string | null;
    unit?: ItemUnintEntity;
    unitPrice?: number;
    maxQuantityPerOrder?: number | null;
    discount?: AppliedDiscountOnItemEntity;
    isAvailable?: boolean;
    hasSelection?: boolean;
    disabled?: boolean;
    selections?: Array<SelectionListedEntity> | null;
}
